import { mergeDeepRight } from 'ramda';

import {
  BAC_COLORS,
  BACCARAT_CRICKET_WAR_ID,
  BACCARAT_DRAGON_BONUS_ID,
  BACCARAT_DRAGON_TIGER_ID,
  BACCARAT_ID,
  BACCARAT_KO_ID,
  BACCARAT_NO_COMMISSION_ID,
  BACCARAT_SUPER_SIX_ID,
  EZ_BACCARAT_ID,
  GAME_ID_FROM_URL,
  BACCARAT_MAIN_BET_TYPES as MAIN_BETS,
  BACCARAT_SIDE_BET_TYPES as SIDEBETS,
  BACCARAT_WINNING_TOTAL_TYPES as WINNING_TOTALS,
} from '@ezugi/constants';
import { DeviceInfo } from '@ezugi/utils';

import {
  PAYOUTS as PAYOUTS_V2,
  NO_COMISSION_PAYOUTS as NO_COMISSION_PAYOUTS_V2,
  NO_COMISSION_PAYOUTS_BO_INDEX_MAP as NO_COMISSION_PAYOUTS_BO_INDEX_MAP_V2,
} from './V2/constants';
import { EZ_BACCARAT_PAYOUTS_BO_INDEX_MAP } from './V2/constants/indexMapBOPayouts';
import batIcon from './assets/icons/cricketwar/batsman_bat.svg';
import gloveIcon from './assets/icons/cricketwar/bowler_glove.svg';
import {
  DRAGON_BONUS_PAYOUTS,
  DRAGON_TIGER_PAYOUTS,
  KNOCKOUT_PAYOUTS,
  NO_COMISSION_PAYOUTS,
  PAYOUTS,
  SUPER_SIX_PAYOUTS,
  CLASSIC_OTT_PAYOUTS_BO_INDEX_MAP,
  NO_COMISSION_PAYOUTS_BO_INDEX_MAP,
  SUPER_SIX_PAYOUTS_BO_INDEX_MAP,
  DRAGON_BONUS_PAYOUTS_BO_INDEX_MAP,
  KNOCKOUT_PAYOUTS_BO_INDEX_MAP,
  DRAGON_TIGER_PAYOUTS_BO_INDEX_MAP,
  CRICKET_WAR_PAYOUTS_BO_INDEX_MAP,
} from './constants';
import { TIE_SUITEDTIE_COMPONENT } from './constants/betgrid';
import { CRICKET_WAR_PAYOUTS } from './constants/payouts';
import {
  desktopStandardGridComponent,
  desktopWideGridComponent,
  portraitGridComponent,
} from './imports';

const { TIE_COLOR } = BAC_COLORS;

const TIE_SIGN = 'T';

const ORIGINAL = 'original';
const LOCALE_ATTRIBUTE_MAP = {
  player: {
    [BACCARAT_DRAGON_TIGER_ID]: 'dragon_label',
    [BACCARAT_CRICKET_WAR_ID]: 'bowler_label',
    [ORIGINAL]: 'player_label',
  },
  banker: {
    [BACCARAT_DRAGON_TIGER_ID]: 'tiger_label',
    [BACCARAT_CRICKET_WAR_ID]: 'batsman_label',
    [ORIGINAL]: 'banker_label',
  },
};

export const UI_CONFIG = {
  COMPONENTS: {
    GAMEBOARD: {
      DESKTOP: {
        COMPONENT: desktopStandardGridComponent,
      },
      PORTRAIT: {
        COMPONENT: portraitGridComponent,
      },
    },
  },
  MAIN_BETS: [ MAIN_BETS.PLAYER, MAIN_BETS.TIE, MAIN_BETS.BANKER ],
  SIDE_BETS: [
    SIDEBETS.EITHER_PAIR,
    SIDEBETS.PERFECT_PAIR,
    SIDEBETS.BIG,
    SIDEBETS.SMALL,
    SIDEBETS.PLAYER_PAIR,
    SIDEBETS.BANKER_PAIR,
  ],
  COLORS: {
    PLAYER_COLOR: '#1a5dc6',
    BANKER_COLOR: '#ce1822',
    TIE_COLOR,
  },
  SIGNS: {
    PLAYER_SIGN: 'P',
    BANKER_SIGN: 'B',
    TIE_SIGN,
  },
  ICONS: {
    PLAYER_ICON: null,
    BANKER_ICON: null,
    TIE_ICON: null,
  },
  TOOLTIPS: {
    TOTAL: 'total_rounds',
    PLAYER: LOCALE_ATTRIBUTE_MAP.player[GAME_ID_FROM_URL] || LOCALE_ATTRIBUTE_MAP.player[ORIGINAL],
    BANKER: LOCALE_ATTRIBUTE_MAP.banker[GAME_ID_FROM_URL] || LOCALE_ATTRIBUTE_MAP.banker[ORIGINAL],
    TIE: 'game_result_tie',
    PLAYERPAIR: 'player_pairs',
    BANKERPAIR: 'banker_pairs',
    PANDA_EIGHT: 'panda_eight',
    DRAGON_SEVEN: 'dragon_seven',
  },
  PAYOUTS,
  GAME_ID: BACCARAT_ID,
  NEW_DESIGN_ENABLED: false,
  isKnockout() {
    return this.GAME_ID === BACCARAT_KO_ID;
  },
  isSuperSix() {
    return this.GAME_ID === BACCARAT_SUPER_SIX_ID;
  },
  isDragonTiger() {
    return this.GAME_ID === BACCARAT_DRAGON_TIGER_ID;
  },
  isNoComission() {
    return this.GAME_ID === BACCARAT_NO_COMMISSION_ID;
  },
  isDragonBonus() {
    return this.GAME_ID === BACCARAT_DRAGON_BONUS_ID;
  },
  isCricketWar() {
    return this.GAME_ID === BACCARAT_CRICKET_WAR_ID;
  },
  isEzBaccarat() {
    return this.GAME_ID === EZ_BACCARAT_ID;
  },
};

const mapUIPayoutsBasedOnBOIndex = (payouts, boIndexMapPayouts) => {
  const updatedPayouts = {};
  Object.keys(payouts).forEach((key) => {
    if (boIndexMapPayouts[key]) {
      updatedPayouts[boIndexMapPayouts[key]] = payouts[Number(key)];
    }
  });
  return updatedPayouts;
};

export const setUIConfigPayouts = (gameId, payouts) => {
  const defaultConfig = UI_CONFIG;
  let configByGameId = {};
  switch (Number(gameId)) {
  case 20: {
    configByGameId = {
      PAYOUTS: mapUIPayoutsBasedOnBOIndex(payouts, KNOCKOUT_PAYOUTS_BO_INDEX_MAP) || KNOCKOUT_PAYOUTS,
    };
    break;
  }
  case 21: {
    configByGameId = {
      PAYOUTS: mapUIPayoutsBasedOnBOIndex(payouts, SUPER_SIX_PAYOUTS_BO_INDEX_MAP) || SUPER_SIX_PAYOUTS,
    };
    break;
  }
  case 24: {
    configByGameId = {
      PAYOUTS: mapUIPayoutsBasedOnBOIndex(payouts, DRAGON_TIGER_PAYOUTS_BO_INDEX_MAP) || DRAGON_TIGER_PAYOUTS,
    };
    break;
  }
  case 25: {
    configByGameId = {
      PAYOUTS:
          UI_CONFIG.NEW_DESIGN_ENABLED
            ? mapUIPayoutsBasedOnBOIndex(payouts, NO_COMISSION_PAYOUTS_BO_INDEX_MAP_V2) || NO_COMISSION_PAYOUTS_V2
            : mapUIPayoutsBasedOnBOIndex(payouts, NO_COMISSION_PAYOUTS_BO_INDEX_MAP) || NO_COMISSION_PAYOUTS,
    };
    break;
  }
  case 26: {
    configByGameId = {
      PAYOUTS: mapUIPayoutsBasedOnBOIndex(payouts, DRAGON_BONUS_PAYOUTS_BO_INDEX_MAP) || DRAGON_BONUS_PAYOUTS,
    };
    break;
  }
  case 45: {
    configByGameId = {
      PAYOUTS: mapUIPayoutsBasedOnBOIndex(payouts, CRICKET_WAR_PAYOUTS_BO_INDEX_MAP) || CRICKET_WAR_PAYOUTS,
    };
    break;
  }
  case 70: {
    configByGameId = {
      PAYOUTS: mapUIPayoutsBasedOnBOIndex(payouts, EZ_BACCARAT_PAYOUTS_BO_INDEX_MAP) || PAYOUTS,
    };
    break;
  }
  default: {
    configByGameId = {
      PAYOUTS: mapUIPayoutsBasedOnBOIndex(payouts, CLASSIC_OTT_PAYOUTS_BO_INDEX_MAP) || PAYOUTS,
    };
    break;
  }
  }
  Object.assign(UI_CONFIG, defaultConfig, configByGameId);

  return configByGameId.PAYOUTS;
};

export const setUIConfigByGameId = (gameId) => {
  const defaultConfig = UI_CONFIG;
  let configByGameId = {};

  switch (Number(gameId)) {
  case 20: {
    configByGameId = {
      COMPONENTS: {
        GAMEBOARD: {
          DESKTOP: { COMPONENT: desktopStandardGridComponent },
          PORTRAIT: { COMPONENT: portraitGridComponent },
        },
      },
      MAIN_BETS: [ MAIN_BETS.PLAYER, MAIN_BETS.TIE, MAIN_BETS.BANKER ],
      SIDE_BETS: [
        SIDEBETS.NATURAL_PLAYER,
        SIDEBETS.NATURAL_BANKER,
        WINNING_TOTALS.TOTALS_1_TO_4,
        WINNING_TOTALS.TOTALS_5_TO_6,
        WINNING_TOTALS.TOTALS_7,
        WINNING_TOTALS.TOTALS_8,
        WINNING_TOTALS.TOTALS_9,
      ],
      PAYOUTS: PAYOUTS || KNOCKOUT_PAYOUTS,
      GAME_ID: 20,
    };
    break;
  }
  case 21: {
    configByGameId = {
      COMPONENTS: {
        GAMEBOARD: {
          DESKTOP: {
            COMPONENT: UI_CONFIG.NEW_DESIGN_ENABLED ? desktopStandardGridComponent : desktopWideGridComponent,
          },
          PORTRAIT: {
            COMPONENT: portraitGridComponent,
            PROPS: { viewBox: '0 0 365 140' },
          },
        },
      },
      MAIN_BETS: [ MAIN_BETS.PLAYER, MAIN_BETS.TIE, MAIN_BETS.BANKER ],
      SIDE_BETS: [ SIDEBETS.SUPER_SIX ],
      PAYOUTS: PAYOUTS || SUPER_SIX_PAYOUTS,
      GAME_ID: 21,
    };
    break;
  }
  case 24: {
    configByGameId = {
      COMPONENTS: {
        GAMEBOARD: {
          DESKTOP: {
            COMPONENT: desktopWideGridComponent,
            PROPS: {
              ...(DeviceInfo.isHandheld
                ? { viewBox: '0 9 570 129' }
                : {
                  style: { transform: 'translate(0, -10px)' },
                  viewBox: '15 9 540 129',
                }),
            },
          },
          PORTRAIT: {
            COMPONENT: portraitGridComponent,
            PROPS: { viewBox: '0 0 365 106' },
          },
        },
      },
      MAIN_BETS: [ MAIN_BETS.DRAGON, TIE_SUITEDTIE_COMPONENT, MAIN_BETS.TIGER ],
      SIDE_BETS: [],
      COLORS: {
        PLAYER_COLOR: BAC_COLORS.DRAGON_COLOR,
        BANKER_COLOR: BAC_COLORS.TIGER_COLOR,
        TIE_COLOR,
      },
      SIGNS: {
        PLAYER_SIGN: 'D',
        BANKER_SIGN: 'T',
        TIE_SIGN,
      },
      PAYOUTS: PAYOUTS || DRAGON_TIGER_PAYOUTS,
      GAME_ID: 24,
    };
    break;
  }
  case 25: {
    configByGameId = {
      ...UI_CONFIG,
      SIDE_BETS: UI_CONFIG.NEW_DESIGN_ENABLED ? [
        ...UI_CONFIG.SIDE_BETS,
        SIDEBETS.PLAYER_OVER,
        SIDEBETS.PLAYER_UNDER,
        SIDEBETS.BANKER_OVER,
        SIDEBETS.BANKER_UNDER,
        SIDEBETS.SUPER_SIX,
      ] : [
        ...UI_CONFIG.SIDE_BETS,
      ],
      PAYOUTS: UI_CONFIG.NEW_DESIGN_ENABLED
        ? (PAYOUTS_V2 || NO_COMISSION_PAYOUTS_V2) : (PAYOUTS || NO_COMISSION_PAYOUTS),
      GAME_ID: 25,
    };
    break;
  }
  case 26: {
    configByGameId = {
      COMPONENTS: {
        GAMEBOARD: {
          DESKTOP: {
            COMPONENT: desktopStandardGridComponent,
            PROPS: {
              ...(!DeviceInfo.isHandheld && {
                style: { transform: 'translate(0, -15px)' },
              }),
            },
          },
          PORTRAIT: {
            COMPONENT: portraitGridComponent,
          },
        },
      },
      MAIN_BETS: [ MAIN_BETS.PLAYER, MAIN_BETS.TIE, MAIN_BETS.BANKER ],
      SIDE_BETS: [ SIDEBETS.DRAGON_BONUS_PLAYER, SIDEBETS.DRAGON_BONUS_BANKER ],
      PAYOUTS: PAYOUTS || DRAGON_BONUS_PAYOUTS,
      GAME_ID: 26,
    };
    break;
  }
  case 45: {
    configByGameId = {
      COMPONENTS: {
        GAMEBOARD: {
          DESKTOP: {
            COMPONENT: desktopWideGridComponent,
            PROPS: {
              ...(DeviceInfo.isHandheld
                ? { viewBox: '0 9 570 129' }
                : {
                  style: { transform: 'translate(0, -10px)' },
                  viewBox: '15 9 540 129',
                }),
            },
          },
          PORTRAIT: {
            PROPS: { viewBox: '0 0 365 106' },
          },
        },
      },
      MAIN_BETS: [
        MAIN_BETS.BOWLER,
        TIE_SUITEDTIE_COMPONENT,
        MAIN_BETS.BATSMAN,
      ],
      SIDE_BETS: [],
      COLORS: {
        PLAYER_COLOR: BAC_COLORS.BOWLER_COLOR,
        BANKER_COLOR: BAC_COLORS.BATSMAN_COLOR,
        TIE_COLOR,
      },
      SIGNS: {
        PLAYER_SIGN: 'B',
        BANKER_SIGN: 'B',
        TIE_SIGN,
      },
      ICONS: {
        PLAYER_ICON: gloveIcon,
        BANKER_ICON: batIcon,
        TIE_ICON: null,
      },
      PAYOUTS: PAYOUTS || CRICKET_WAR_PAYOUTS,
      GAME_ID: 45,
    };
    break;
  }
  case 70: {
    configByGameId = {
      ...UI_CONFIG,
      SIDE_BETS: [
        SIDEBETS.PANDA_EIGHT,
        SIDEBETS.DRAGON_SEVEN,
      ],
    };
    break;
  }
  default: {
    configByGameId = {
      ...UI_CONFIG,
      SIDE_BETS: UI_CONFIG.NEW_DESIGN_ENABLED ? [
        ...UI_CONFIG.SIDE_BETS,
        SIDEBETS.PLAYER_OVER,
        SIDEBETS.PLAYER_UNDER,
        SIDEBETS.BANKER_OVER,
        SIDEBETS.BANKER_UNDER,
      ] : [
        ...UI_CONFIG.SIDE_BETS,
      ],
    };
    break;
  }
  }

  Object.assign(UI_CONFIG, mergeDeepRight(defaultConfig, configByGameId));
};
